import React from 'react';
import {
  Paper,
  Typography,
  Grid,
  Box,
  List,
  ListItem,
  ListItemText,
  Chip
} from '@mui/material';
import { Build } from '@mui/icons-material';

const MaintenanceAlertsCard = ({ maintenanceAlerts }) => {
  if (maintenanceAlerts.overdue.length === 0 && maintenanceAlerts.upcoming.length === 0) {
    return null;
  }

  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      <Typography variant="h6" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Build color="error" />
        Maintenance Alerts
      </Typography>
      <Grid container spacing={2}>
        {maintenanceAlerts.overdue.length > 0 && (
          <Grid item xs={12} sm={6} md={6}>
            <Box sx={{ p: 1, border: '1px solid', borderColor: 'error.main', borderRadius: 1, bgcolor: 'rgba(211, 47, 47, 0.1)' }}>
              <Typography variant="body2" color="error.main" fontWeight="bold">Overdue Maintenance</Typography>
              <Typography variant="h5" color="error.main">{maintenanceAlerts.overdue.length}</Typography>
              <Typography variant="caption" color="textSecondary">work orders past scheduled date</Typography>
              <List dense sx={{ mt: 1, maxHeight: '150px', overflowY: 'auto' }}>
                {maintenanceAlerts.overdue.slice(0, 5).map((m) => (
                  <ListItem key={m._id} dense>
                    <ListItemText
                      primary={m.title}
                      secondary={
                        m.aircraftId?.registration 
                          ? `${m.aircraftId.registration} • ${m.scheduledDate ? new Date(m.scheduledDate).toLocaleDateString() : 'N/A'}`
                          : m.scheduledDate ? new Date(m.scheduledDate).toLocaleDateString() : 'N/A'
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          </Grid>
        )}
        {maintenanceAlerts.upcoming.length > 0 && (
          <Grid item xs={12} sm={6} md={6}>
            <Box sx={{ p: 1, border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
              <Typography variant="body2" color="textSecondary">Upcoming Maintenance (Next 30 Days)</Typography>
              <Typography variant="h5">{maintenanceAlerts.upcoming.length}</Typography>
              <Typography variant="caption" color="textSecondary">scheduled work orders</Typography>
              <List dense sx={{ mt: 1, maxHeight: '150px', overflowY: 'auto' }}>
                {maintenanceAlerts.upcoming.slice(0, 5).map((m) => (
                  <ListItem key={m._id} dense>
                    <ListItemText
                      primary={m.title}
                      secondary={
                        m.aircraftId?.registration 
                          ? `${m.aircraftId.registration} • ${m.scheduledDate ? new Date(m.scheduledDate).toLocaleDateString() : 'N/A'}`
                          : m.scheduledDate ? new Date(m.scheduledDate).toLocaleDateString() : 'N/A'
                      }
                    />
                    <Chip 
                      label={m.scheduledDate ? new Date(m.scheduledDate).toLocaleDateString() : 'N/A'} 
                      size="small" 
                      color={m.scheduledDate && new Date(m.scheduledDate) <= new Date(Date.now() + 7 * 24 * 60 * 60 * 1000) ? 'warning' : 'default'}
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};

export default MaintenanceAlertsCard;

